/**
 * Legal content loader. (CO 069)
 * Renders the canonical legal markdown (ported from comai-plan/docs/legal) as
 * real pages. Build-time glob; no MUI.
 */

const files = import.meta.glob("./legal/*.md", {
  query: "?raw",
  import: "default",
  eager: true,
}) as Record<string, string>;

export interface LegalDoc {
  slug: string;
  title: string;
  body: string;
}

const TITLES: Record<string, string> = {
  privacy: "Privacy Policy",
  terms: "Terms of Service",
  "acceptable-use": "Acceptable Use Policy",
  cookies: "Cookie Policy",
  dpa: "Data Processing Agreement",
};

const docs: Record<string, LegalDoc> = {};
for (const [path, body] of Object.entries(files)) {
  const slug = path.split("/").pop()!.replace(/\.md$/, "");
  docs[slug] = { slug, title: TITLES[slug] ?? slug, body };
}

export function getLegalDoc(slug: string): LegalDoc | undefined {
  return docs[slug];
}

export const LEGAL_DOCS: LegalDoc[] = Object.values(docs);
